<template>
  <div>
    <collection-upload-box :colID="colID" boxHeight="300px"></collection-upload-box>
  </div>
</template>
<script>
import Uploader from "./CollectionAssetUploadWrapper";

export default {
  name: "uploader",
  components: {
    "collection-upload-box": Uploader,
  },
  computed: {
    colID() {
      return this.$route.params.id;
    },
  },
};
</script>
